import React, { useEffect, useState } from "react"
import moment from "moment"
import "moment/locale/pt-br"
moment.locale("pt-br")
import { useNavigate } from "react-router-dom"
import { RiCloseFill } from "react-icons/ri"
import { MdCopyAll, MdDelete } from "react-icons/md"
import ReactTableContainer from "../ReactTable"
import PhoneContainer from "../../container/PhoneContainer"
import { InfoTooltip, ReactCustomTooltip } from "../../components/Tooltip"
import { AvatarIcon } from "../Avatar"
import { useCopyClipBoard } from "../../core/utils/hooks/copyToClipBoard"
import { sortUsers } from "../../core/utils/sort"
import ModalAlert from "../ModalAlert"
import { FaAngleRight, FaWhatsapp } from "react-icons/fa"
import { isMobile } from "react-device-detect"
import "./styles.scss"
import { useScope } from "../../container/SelectProjectCompanyContainer"
import { useSelector } from "react-redux"
import { useWindowResize } from "../../core/utils/hooks/windowResize"
import { HiOutlinePencil } from "react-icons/hi";

const RenderTags = ({ item, handleRemoveTag, selecteds }) => {
  const isSelected = selecteds && selecteds?.length > 0
  return (
    <div
      key={item?.tagUserId || item?.tag?.tagLink}
      disabled={isSelected}
      title={isSelected ?  "Ação permitida quando não houver usuários selecionados" : item?.tag.name }
      style={{
        backgroundColor: item?.tag.color,
        color: item?.tag?.text_color,
        cursor: isSelected ? "not-allowed" : "pointer",
      }}
      onClick={isSelected ? () => {} : () =>
        ModalAlert.danger({
          title: "Deseja remover esta tag ?",
          confirmLabel: "Confirmar",
          onConfirm: () => {
            typeof handleRemoveTag === "function" &&
              handleRemoveTag(item?.tagUserId || item?.tag?.tagLink)
          },
        })
      }
      className="badge rounded-pill">
      <span>{item?.tag.name}</span>
      <RiCloseFill />
    </div>
  )
}

function truncateString(str) {
  if (str?.length > 23) {
    return str.substring(0, 23) + "..."
  }
  return str
}

export const UserAvatarInfo = ({ row, padding = true, fixed = true, phone = false, className }, handleNavigateToProfile) => {
  const copyToClipBoard = useCopyClipBoard()

  const dataUser = {
    nome:
      row?.original?.PRODUTOR ||
      row?.original?.Produtor ||
      row?.original?.user?.name ||
      row?.original?.name ||
      row?.name,
    email:
      row?.original?.PRODUTOR_EMAIL ||
      row?.original?.email ||
      row?.original?.user?.email ||
      row?.original?.Email ||
      row?.email,
    phone: row?.original?.whatsapp || row?.original?.phone,
    image: row?.original?.image || row?.image,
  }

  return (
    <div className="avatar-cell-container" key={row?.index}>
      <InfoTooltip info={"Acessar perfil de " + truncateString(dataUser.nome)} >
        {phone && <div className="header-avatar">Ligar Para:</div>}
        <div
          className={`user-avatar-cell ${className ? className : ""} ${padding ? "" : "not-padding"
            }`}
          title={dataUser.nome}
          onClick={() => handleNavigateToProfile(row?.original)}>
          {isMobile ? (
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <div>
                <AvatarIcon
                  title={dataUser.nome}
                  name={dataUser.nome}
                  icon={row?.original?.image || row?.image}
                />
              </div>
              <div>
                <div className={`user-info ${fixed ? "" : "fixed"} `}>
                  <div className="user-name">{truncateString(dataUser.nome)}</div>
                  {dataUser.phone ? (
                    <div className="user-email">
                      <div className="whatsapp-icon">
                        <FaWhatsapp />
                      </div>{" "}
                      {dataUser.phone}
                    </div>
                  ) : (
                    <div className="user-email">{dataUser.email}</div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="user-avatar">
                <AvatarIcon
                  title={dataUser.nome}
                  name={dataUser.nome}
                  icon={row?.original?.image || row?.image}
                />
              </div>
              <div className={`user-info ${fixed ? "" : "fixed"} `}>
                <div className="user-name">{dataUser.nome}</div>
                {phone ? (
                  <div className="user-email"> {row?.original?.phone || row.phone}</div>
                ) : (
                  <div className="user-email">{dataUser.email}</div>
                )}
              </div>
            </>
          )}
          {/* {!phone && !isMobile && (
          <div className="button-copy" title="Copiar usuário">
            <MdCopyAll size={17} />
          </div>
        )} */}
        </div>
      </InfoTooltip>
    </div>
  )
}

export const TecnicalCell = ({ row }) => {
  return (
    <div className="avatar-cell-container">
      <div className="user-avatar-cell">
        <div className="user-avatar">
          <AvatarIcon name={row.original.Tecnico} icon={row?.original?.image} />
        </div>
        <div className="user-info">
          <div className="user-name">{row.original.Tecnico}</div>
          {row.original.email && <div className="user-email">{row.original.email}</div>}
        </div>
      </div>
    </div>
  )
}

export const StatusPillCell = ({ value }) => {
  const status = value ? `${value}`.toLowerCase() : "unknown"
  let statusPillColor = ""
  return (
    status.startsWith(+1) ? (statusPillColor = "status-pill--primary-green") : null,
    status.startsWith(+0) ? (statusPillColor = "status-pill--yellow") : null,
    status.startsWith("") ? (statusPillColor = "status-pill--gray") : null,
    (
      <div className="status-pill-container">
        <div className={`status-pill ${statusPillColor}`}></div>
      </div>
    )
  )
}

export const AnalyticsPillCell = ({ row, value }) => {
  return (
    <>
      {row?.original?.lastAcitvity?.status === "Ativo" ? (
        <div className="status-pill-container">
          <div title={`Último evento ${row?.original?.lastAcitvity.activity}`}>
            {row?.original?.lastAcitvity.activity}
          </div>
        </div>
      ) : (
        <div className="status-pill-container status-pill-container-empty">Inativo</div>
      )}
    </>
  )
}

export const CityCell = (value, row, openEditCityAndState, isState = false, selecteds) => {
  const isSelected = selecteds?.length > 0;
  const displayValue = value || (isState ? "Não cadastrado" : "Não cadastrada");

  return (
    <div className="status-pill-container">
      <div className="title" title={displayValue}>{displayValue}</div>
      <button
        disabled={isSelected}
        title={isSelected ? "Ação permitida quando não houver usuários selecionados" : ""}
        style={{
          backgroundColor: "transparent",
          border: "none",
          cursor: isSelected ? "not-allowed" : "pointer",
          marginLeft: 8
        }}
        onClick={() => !isSelected && openEditCityAndState(row, isState ? "state" : "counties")}
      >
        <HiOutlinePencil
          style={{
            color: "#afbcaf",
            fontSize: "18px",
            justifyContent: "center",
          }}
        />
      </button>
    </div>
  );
};

export const TermsAcceptedCell = ({ value }) => {
  const date = value ? new Date(value).toLocaleDateString() : "Pendente"
  // const date = value && value.timestamp
  // // let statusPillColor = ""
  return <div className="status-pill-container">{date}</div>
}

export const JourneyCell = ({ row }) => {
  const navigate = useNavigate()
  const onPress = () => {
    navigate(`/evidence/${row.original.id}`)
  }
  return (
    <div className="status-pill-container evidence">
      <div href="#" onClick={onPress}>
        Ver evidências
      </div>
    </div>
  )
}

export const FarmerProfileCell = ({ row }) => {
  const navigate = useNavigate()

  const onPress = () => {
    navigate(`/farmer/profile/${row?.original?.id}`, { state: { fromUsers: row?.original } })
  }

  return (
    <div className="status-pill-container evidence">
      <div href="#" onClick={onPress}>
        {isMobile ? <FaAngleRight fontSize={"20px"} color="#0c7349" /> : "Ver"}
      </div>
    </div>
  )
}

export const GlobalFilter = () => {
  return (
    <input
      type="text"
      className="table-filter-search"
      value={""}
      onChange={() => { }}
      placeholder={"Pesquisar Usuário"}
    />
  )
}

const getTagValues = (data) => {
  if (Array.isArray(data)) {
    return (
      data &&
      data
        ?.map((tag) => ({ tag, tagUserId: tag.tagUserId }))
        ?.filter((item) => item.tag.id !== null)
    )
  } else {
    return (
      data &&
      Object?.values(
        data?.original?.tag_user
          ?.map((tag) => ({ tag, tagUserId: tag.tagUserId }))
          ?.filter((item) => item.tag.id !== null),
      )
    )
  }
}

const renderTagList = (tags, handleRemoveTag, selecteds) => {
  const list = getTagValues(tags).splice(0, 3)
  const listAll = getTagValues(tags).slice(3)

  return (
    <div className="tags">
      {list?.length > 0 ? (
        list.map((item) => (
          <div key={item.id}>
            <RenderTags {...{ item, handleRemoveTag, selecteds }} />
          </div>
        ))
      ) : (
        <div className="tags-empty">Não há tags disponíveis</div>
      )}
      {listAll?.length > 0 && (
        <ReactCustomTooltip labelbutton="Mais Tags" variant="white" className="more-tags">
          {listAll.map((item) => (
            <div key={item.id}>
              <RenderTags {...{ item, handleRemoveTag, selecteds }} />
            </div>
          ))}
        </ReactCustomTooltip>
      )}
    </div>
  )
}

export const TagsCell = ({ row, data }, handleRemoveTag, selecteds) => {
  const tags = row || data?.tags
  return renderTagList(tags, handleRemoveTag, selecteds)
}

export const TagsCellGrid = ({ row, data, handleRemoveTag }) => {
  const tags = row || data?.tags
  return renderTagList(tags, handleRemoveTag)
}

const UserList = ({
  selecteds,
  data,
  onSelect,
  clearCall,
  handleRemoveTag,
  openEditCityAndState = () => {},
  handleDeleteBeneficiary = () => {},
  handleNavigateToProfile = () => {},
  loading
}) => {
  const [windowWidth] = useWindowResize();
  const [sorted, setSorted] = useState([]);
  const { scope } = useScope();
  const currentUser = useSelector((state) => state.app?.user?.user);
  const navigate = useNavigate();

  useEffect(() => {
    if (data) setSorted(sortUsers(data));
  }, [data]);

  const handleNavigateToCadastro = (row) => {
    navigate(`/farmer/profile/${row?.original?.id}`, {
      state: { tab: 5, fromUsers: row?.original }
    });
  };

  const ActionButton = ({ onClick, icon: Icon, disabled }) => (
    <button
      disabled={disabled}
      title={disabled ? "Ação permitida quando não houver usuários selecionados" : ""}
      style={{
        backgroundColor: "transparent",
        border: "none",
        cursor: disabled ? "not-allowed" : "pointer"
      }}
      onClick={onClick}
    >
      <Icon style={{ color: "#afbcaf", fontSize: "18px" }} />
    </button>
  );

  const columns = [
    {
      Header: "Nome e Email",
      accessor: "name",
      Cell: (info) => UserAvatarInfo(info, handleNavigateToProfile),
      width: isMobile ? "calc(100% - 80px)" : "calc(100% - 1100px)",
      minWidth: "calc(100% - 1100px)",
    },
    !isMobile && {
      Header: "Whatsapp",
      accessor: "phone",
      Cell: ({ value, row }) => (
        <PhoneContainer
          value={value}
          scope={scope}
          currentUser={currentUser}
          row={row}
          clearCall={clearCall}
        />
      ),
      width: "190",
      minWidth: "185px !important",
    },
    !isMobile && {
      Header: "Tags",
      accessor: "tag_user",
      Cell: (value) => TagsCell(value, handleRemoveTag, selecteds),
      width: "300",
      minWidth: "300",
    },
    !isMobile && {
      Header: "Cidade",
      accessor: "city",
      Cell: ({ value, row }) => CityCell(value, row, openEditCityAndState, false, selecteds),
      width: "180",
      minWidth: "180",
    },
    !isMobile && {
      Header: "Estado",
      accessor: "state",
      Cell: ({ value, row }) => CityCell(value, row, openEditCityAndState, true, selecteds),
      width: "180",
      minWidth: "180",
    },
    !isMobile && {
      Header: "Editar",
      accessor: "edit",
      Cell: ({ row }) => (
        <ActionButton
          onClick={() => handleNavigateToCadastro(row)}
          icon={HiOutlinePencil}
          disabled={selecteds?.length > 0}
        />
      ),
      width: "100",
      minWidth: "60",
    },
    !isMobile && {
      Header: "Excluir",
      accessor: "delete",
      Cell: ({ row }) => (
        <ActionButton
          onClick={() => handleDeleteBeneficiary(row.original.id)}
          icon={MdDelete}
          disabled={selecteds?.length > 0}
        />
      ),
      width: "100",
      minWidth: "60",
    },
  ].filter(item => item);

  return (
    <ReactTableContainer
      className="table-user"
      selecteds={selecteds}
      onSelect={onSelect}
      canSelect={true}
      height={isMobile ? 80 : null}
      columns={columns}
      data={sorted || data}
      loadingTable={loading}
      widthSetted={windowWidth - 320}
    />
  );
};


export default UserList